$(window).on('load', function() {
    $(window).trigger('resize');
  
    jQuery.ajax( { 
      url: '//freegeoip.net/json/', 
      type: 'POST', 
      dataType: 'jsonp',
      success: function(location) {
        if (location.country_code == 'GB') {
          $("#currencies").val("GBP");
          $("#currencies").change();
        }
        if (location.country_code == 'US') {
          $("#currencies").val("USD");
          $("#currencies").change();
        }
        if (location.country_code == 'CN') {
          $("#currencies").val("CNY");
          $("#currencies").change();
        }
        if (location.country_code == 'AU') {
          $("#currencies").val("AUS");
          $("#currencies").change();
        }
        if (location.country_code == 'JP') {
          $("#currencies").val("JPN");
          $("#currencies").change();
        }
      }
    });
  
 });
$(document).ready(function(){
  if ( $('.product-photos').length ) {
    if ($(window).width() > 800) {
      var productPhotos = new SimpleBar(document.querySelector('.product-photos'));
      $(window).on('resize', function() {
        console.log(productPhotos.SimpleBar);
        productPhotos.SimpleBar.recalculate();
      });
    }
  }
//   alert(Modernizr.hiddenscroll);
  $('.masthead #logo').mouseover( function(e){
    if ( ! $(".site--header").hasClass('prohibited') ) {
      $(".site--header").addClass('child_hover');
      $(this).attr('data-hover', 'true');
    }
    e.stopPropagation();
  }).mouseleave( function(e){
    $(".site--header").removeClass('child_hover');
    $(this).attr('data-hover', 'false');
    e.stopPropagation();
  });
  $('.site--header').mouseenter( function(e){
    if ( 'true' != $('.masthead #logo').attr('data-hover') ) {
      $(".site--header").addClass('prohibited');
    } else {
      $(".site--header").removeClass('prohibited');
    }
    e.stopPropagation();
  }).mouseleave( function(e){
    $(".site--header").removeClass('prohibited');
    e.stopPropagation();
  });
  if ( ! $('body').hasClass('loaded') ) { 
    $('body').addClass('loaded');
    // Annoying Chrome VH fix
    if ( $(".product-photos").length ) {
      $(".product-photos").css( 'height', $(".product-photos").outerHeight() );
    }
    if ( $("#shopify-section-header .slide").length ) {
      $("#shopify-section-header .slide").each( function(){
        $(this).css( 'height', $(this).outerHeight() );
      });
    }


    if ( $('#shopify-section-header').length ) {
      $('#shopify-section-header').slick({
        fade: true,
        dots: true,
        arrows: false,
        draggable: false,
        infinite: true
      });
      window.topofDiv = $("#shopify-section-header").offset().top; //gets offset of header
      window.height = $("#shopify-section-header").outerHeight() - $(".site--header").outerHeight(); //gets height of header

      $(window).scroll(function(){
        window.requestAnimationFrame(step);
      });
    }
    if ( $('input[type="number"]').length ) {
      $('input[type="number"]').each( function(){
        $(this).wrap( "<div class='quantity_wrap'></div>" );
        fieldName = $(this).attr('name');
        var input = this,
            minus = $( "<input type='button' value='-' class='quantity_button minus' field='" + fieldName + "' />" ),
            plus = $( "<input type='button' value='+' class='quantity_button plus' field='" + fieldName + "' />" );
        $(this).before( $(minus) );
        $(this).after( $(plus) );

        $(plus).click(function(e){
            // Stop acting like a button
            e.preventDefault();
            // Get the field name
            fieldName = $(this).attr('field');
            // Get its current value
            var currentVal = parseInt($(input).val());
            // If is not undefined
            if (!isNaN(currentVal)) {
                // Increment
                $(input).val(currentVal + 1);
            } else {
                // Otherwise put a 0 there
                $(input).val(0);
            }
        });
        // This button will decrement the value till 0
        $(minus).click(function(e) {
            // Stop acting like a button
            e.preventDefault();
            // Get the field name
            fieldName = $(this).attr('field');
            // Get its current value
            var currentVal = parseInt($(input).val());
            // If it isn't undefined or its greater than 0
            if (!isNaN(currentVal) && currentVal > 0) {
                // Decrement one
                $(input).val(currentVal - 1);
            } else {
                // Otherwise put a 0 there
                $(input).val(0);
            }
        });
      });
    }
    if ( $('.homepage_collection_slider').length ) {
      $('.homepage_collection_slider').each( function(){
        $(this).slick({
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          draggable: false,
          infinite: true,
          fade: true,
          touchMove: false,
          swipe: false
        });
      });
    }
    if ( $('#shopify-section-featured_collections .product_slider').length ) {
      $('#shopify-section-featured_collections .product_slider').each( function(){
        $(this).slick({
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
//           centerPadding: '8%',
          dots: false,
          draggable: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ] 
        });
      });
    }
    if ( $('#shopify-section-featured-collection .product_slider').length ) {
      $('#shopify-section-featured-collection .product_slider').each( function(){
        $(this).slick({
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          draggable: true
        });
      });
    }
    if ( $('.collection_details--slider').length ) {
      $('.collection_details--slider').each( function(){
        $(this).slick({
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          draggable: true,
          infinite: true
        });
      });
    }
    if ( $('.product .product-photos').length ) {
      $('.product .product-photos').slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        dots: false,
        draggable: true,
        infinite: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 640,
            settings: "unslick"
          }
        ]
      });
    }
    if ( $('.featured_products--wrapper').length ) {
      $('.featured_products--wrapper').slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        draggable: true,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 640,
            settings: "unslick"
          }
        ]
      });
    }
    if ( $('.template-collection .pagination .next').length ) {
      var more_url = $('.template-collection .pagination .next a').attr('href'),
          load_more = $('<a href="' + more_url + '" class="black_button"><span>Load more</span></a>');
      $('.template-collection .pagination').html( load_more );
      $(load_more).click( function(e){
        if ( ! $(this).hasClass('disabled') ) {
          $(this).addClass('disabled');
          $('body').append('<div id="load_buffer"></div>');
          $('#load_buffer').load($(this).attr('href') + ' #main', function(){
            $('#load_buffer .collection_grid li').appendTo($('#main .collection_grid'));
            if ( $('#load_buffer .pagination .next').length ) {
              var more_url = $('#load_buffer .pagination .next a').attr('href');
              $('#main .pagination a').attr( 'href', more_url ).removeClass('disabled');
            } else {
              $('#main .pagination').html('');
            }
            $(this).removeClass('disabled');
            $('#load_buffer').remove();
          });
        }
        return false;
      });
    }
    if ( $('.press_list').length ) {
      $('.press_list').addClass('animated fullwidth');
      $('.press_list').clone(true, true).contents().appendTo('.press_list');
      $('.press_list').clone(true, true).contents().appendTo('.press_list');
      $('.press_list').clone(true, true).contents().appendTo('.press_list');
      $('.press_list').clone(true, true).contents().appendTo('.press_list');
    }
  }
});
function step() {
    if($(window).scrollTop() < (topofDiv + height)){
      $('#shopify-section-header').css({
        'transform' : "translateY("+($(this).scrollTop()/3)+"px)"
      }); 
    }
    if($(window).scrollTop() > 0){
      $(".site--header").addClass('block-logo');
    } else {
      $(".site--header").removeClass('block-logo');
    }
  	if($(window).scrollTop() > window.innerHeight){
      $(".site--header").addClass('block');
    } else {
      $(".site--header").removeClass('block');
    }
}
function instafeedSlider() {
    $('#instafeed').slick({
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      draggable: true,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });
}